const textLight = {
    primary: 'rgba(52, 49, 76, 1)',
    secondary: 'rgba(52, 49, 76, 0.54)',
    disabled: 'rgba(52, 49, 76, 0.38)',
    hint: 'rgba(52, 49, 76, 0.38)',
}
const secondaryColor = {
    light: '#f9a352',
    main: '#ff9e43',
    dark: '#ff932e',
    contrastText: textLight.primary,
}
const errorColor = {
    main: '#FF3D57',
}

const success2color = {
    main: "#6fff97"
}

export const themeColors = {
    EbeeDark: {
        palette: {
            type: 'dark',
            primary: {
                main: '#222A45',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    EbeeBlue: {
        palette: {
            type: 'light',
            primary: {
                main: '#9400d3',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            buttonAll: {
                main: '#546de5',
                contrastText: '#ffffff',
            },
            buttonToDay: {
                main: '#2ecc71',
                contrastText: '#ffffff',
            },
            buttonPickup: {
                main: '#3dc1d3',
                contrastText: '#ffffff',
            },
            buttonDelivery: {
                main: '#e15f41',
                contrastText: '#ffffff',
            },
            buttonNoReady: {
                main: '#f78fb3',
                contrastText: '#ffffff',
            },
            secondary: {
                main: '#ff9077',
                contrastText: textLight.primary,
            },
            ebeePrimary:{
                main: '#9400d3',
                contrastText: '#ffffff',
            },
            error: errorColor,
            success2:success2color,
            text: textLight,
        },
    },
    EbeePurplDark: {
        palette: {
            type: 'dark',
            primary: {
                main: '#9400d3',
                contrastText: '#ffffff',
            },
            buttonAll: {
                main: '#546de5',
                contrastText: '#ffffff',
            },
            buttonToDay: {
                main: '#2ecc71',
                contrastText: '#ffffff',
            },
            buttonPickup: {
                main: '#3dc1d3',
                contrastText: '#ffffff',
            },
            buttonDelivery: {
                main: '#e15f41',
                contrastText: '#ffffff',
            },
            buttonNoReady: {
                main: '#f78fb3',
                contrastText: '#ffffff',
            },
            secondary: {
                main: '#FF4F30',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    EbeePurplWhite: {
        palette: {
            type: 'light',
            primary: {
                // main: '#fcfaff',
                main: '#ffffff',
                contrastText: '#9400d3',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: '#ffffff',
            },
            buttonAll: {
                main: '#546de5',
                contrastText: '#ffffff',
            },
            buttonToDay: {
                main: '#2ecc71',
                contrastText: '#ffffff',
            },
            buttonPickup: {
                main: '#3dc1d3',
                contrastText: '#ffffff',
            },
            buttonDelivery: {
                main: '#e15f41',
                contrastText: '#ffffff',
            },
            buttonNoReady: {
                main: '#f78fb3',
                contrastText: '#ffffff',
            },
            secondary: {
                main: '#FF7300',
                contrastText: "#FFFFFF",
                // contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    EbeeIconTopBar: {
        palette: {
            type: 'light',
            primary: {
                main: '#9400d3',
                contrastText: '#ffffff',
            },
            secondary: {
                main: '#FF7300',
                contrastText: "#FFFFFF",
                // contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    whitePurple: {
        palette: {
            type: 'light',
            primary: {
                main: '#ffffff',
                contrastText: textLight.primary,
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#7467ef',
                contrastText: '#ffffff',
            },
            error: errorColor,
            success2:success2color,
            text: textLight,
        },
    },
    whiteBlue: {
        palette: {
            type: 'light',
            primary: {
                main: '#ffffff',
                contrastText: textLight.primary,
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#1976d2',
                contrastText: '#ffffff',
            },
            text: textLight,
            success2:success2color,
        },
    },
    slateDark1: {
        palette: {
            type: 'dark',
            primary: {
                main: '#222A45',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    slateDark2: {
        palette: {
            type: 'dark',
            primary: {
                main: '#1a2038',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    purple1: {
        palette: {
            type: 'light',
            primary: {
                main: '#7467ef',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: secondaryColor,
            error: errorColor,
            success2:success2color,
            text: textLight,
        },
    },
    purple2: {
        palette: {
            type: 'light',
            primary: {
                main: '#6a75c9',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            text: textLight,
        },
    },
    purpleDark1: {
        palette: {
            type: 'dark',
            primary: {
                main: '#7467ef',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    purpleDark2: {
        palette: {
            type: 'dark',
            primary: {
                main: '#6a75c9',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#ff9e43',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    blue: {
        palette: {
            type: 'light',
            primary: {
                main: '#1976d2',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#FFAF38',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            text: textLight,
        },
    },
    blueDark: {
        palette: {
            type: 'dark',
            primary: {
                main: '#1976d2',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#FF4F30',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
            background: {
                paper: '#222A45',
                default: '#1a2038',
            },
        },
    },
    red: {
        palette: {
            type: 'dark',
            primary: {
                main: '#e53935',
                contrastText: '#ffffff',
            },
            primaryTwo: {
                main: '#9400d3',
                contrastText: textLight.primary,
            },
            secondary: {
                main: '#FFAF38',
                contrastText: textLight.primary,
            },
            error: errorColor,
            success2:success2color,
        },
    },
}
